import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { GuildState } from '../../models/guild';
import * as guildService from '../../services/guildService';

// Initial state
const initialState: GuildState = {
  guilds: [],
  loading: {
    guilds: false,
  },
  error: {
    guilds: null,
  },
};

// Async thunks
export const fetchFullGuilds = createAsyncThunk(
  'guilds/fetchFullGuilds',
  async (_, { rejectWithValue }) => {
    try {
      const guilds = await guildService.getAllFullGuilds();
      return guilds;
    } catch (error: any) {
      return rejectWithValue(error.message || 'Failed to fetch guilds');
    }
  }
);

// Slice
const guildSlice = createSlice({
  name: 'guilds',
  initialState,
  reducers: {
    clearErrors: (state) => {
      state.error = {
        guilds: null,
      };
    },
    clearError: (state, action: PayloadAction<keyof GuildState['error']>) => {
      state.error[action.payload] = null;
    },
  },
  extraReducers: (builder) => {
    // Fetch full guilds
    builder
      .addCase(fetchFullGuilds.pending, (state) => {
        state.loading.guilds = true;
        state.error.guilds = null;
      })
      .addCase(fetchFullGuilds.fulfilled, (state, action) => {
        state.loading.guilds = false;
        state.guilds = action.payload || [];
      })
      .addCase(fetchFullGuilds.rejected, (state, action) => {
        state.loading.guilds = false;
        state.error.guilds = action.payload as string;
      });
  },
});

export const { clearErrors, clearError } = guildSlice.actions;

export default guildSlice.reducer;
